import { ITag, TagInDatabase, TagInDatabaseSchema } from '@/validations/tag';
import { getFirestore, collection, CollectionReference, getDoc, doc } from 'firebase/firestore';

import { toast } from '@/components/Toaster/Toast';

import { safePromise } from './safePromise';

export async function getFirebaseTag(tagId: string, organizationId: string): Promise<ITag | undefined> {
  const firestore = getFirestore();

  const tagsReference = collection(
    firestore,
    'organizations',
    organizationId,
    'tags',
  ) as CollectionReference<TagInDatabase>;

  // Get the config from the database
  const [data, error] = await safePromise(getDoc(doc(tagsReference, tagId)));

  if (error) {
    toast({
      variant: 'error',
      title: 'Unable to fetch tag',
      description: 'Please try again later',
    });

    return undefined;
  }

  // Check if the config exists
  if (!data || !data.exists()) {
    console.error(`Tag with ID ${tagId} not found in organization ${organizationId}`);
    console.error('Data:', data);
    toast({
      variant: 'error',
      title: 'Could not find tag',
      description: 'Please try again later',
    });

    // @TODO: After we migrated all tags this should be removed
    return {
      id: tagId,
      label: tagId,
      user: '',
    };
  }

  const tag = TagInDatabaseSchema.safeParse(data.data());

  if (!tag.success) {
    toast({
      variant: 'error',
      title: 'Invalid tag',
      description: 'Please try again later',
    });

    return undefined;
  }

  return {
    ...tag.data,
    id: tagId,
  };
}

export type { ITag, TagInDatabase };
